import React, {Component, PropTypes} from 'react';
import {Col} from 'react-bootstrap';
import styled from 'styled-components';

import PaymentHistoryItem from './PaymentHistoryItem/PaymentHistoryItem';
import CurrencyType from '../../../constants/CurrencyType';
import moment from 'moment';
import PaymentStatus from '../../../constants/PaymentStatus';
import {Button} from "@sketchpixy/rubix";
import AddPaymentModal from "./AddPaymentModal";

const Root = styled(Col)`
  padding: 0;
`;

const Title = styled.div`
  height: 65px;
  border-bottom: 2px solid #d8d8d8;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

class PaymentHistory extends Component {
  constructor(props) {
    super(props);

     this.state = {
       paymentList: this.props.paymentList,
       showAddPaymentModal: false,
     };
  }


  componentWillReceiveProps(nextProps) {
    this.state = {
      paymentList: nextProps.paymentList,
      showAddPaymentModal: false,
    };
  }

  getCreatedDateTime(timestamp) {
    return moment(timestamp).format('YYYY-MM-DD hh:mm:ss');
  }

  addPayment = () => {
    this.setState({
      showAddPaymentModal: true,
    });
  };

  closeAddPaymentModal = (updated) => {
    this.setState({
      showAddPaymentModal: false,
    });

    if(updated)
    {
      this.paymentUpdated()
    }
  };

  paymentUpdated = () => {
     this.props.paymentUpdated()
  };

  paymentAdded = () => {
    this.setState({
      showAddPaymentModal: false,
    });

    this.props.paymentUpdated()
  };


  render() {
    let paymentList = this.state.paymentList;

    let notExist = null;
    if (paymentList.length === 0 && !this.props.schedule) {
      notExist = (<div>It's not exist.</div>);
    }


    return (
        <Root xs={12}>
          <Title>Payment History <Button bsStyle='red' style={{marginLeft:"20px"}} onClick={this.addPayment}>Add</Button></Title>
          {notExist}
          {
            paymentList.map(payment => {
              const createdDate = this.getCreatedDateTime(payment.createdTime);
              const amount = payment.paymentAmount;
              const description = payment.description;
              const paymentStatus = PaymentStatus.enumValueOf(payment.paymentStatus);

              return (
                  <PaymentHistoryItem
                      key={payment.paymentId}
                      createdDate={createdDate}
                      paymentTime={payment.paymentTime}
                      currency={this.props.currency}
                      currencyType={this.props.currencyType}
                      amount={amount}
                      paymentId={payment.paymentId}
                      failedCount={payment.failedCount}
                      expectedPaymentDate={payment.expectedPaymentDate}
                      expectedPaymentMonth={payment.expectedPaymentMonth}
                      paymentStatus={paymentStatus}
                      description={description}
                      paymentStatusChanged={this.paymentUpdated}
                  />
              );
            })
          }
          <AddPaymentModal
              contract={this.props.contract}
              showModal={this.state.showAddPaymentModal}
              paymentAdded={this.paymentAdded}
              closeModal={this.closeAddPaymentModal}
          />
        </Root>
    );
  }
}

PaymentHistory.propTypes = {
  paymentUpdated: PropTypes.func.isRequired,
  paymentList: PropTypes.arrayOf(PropTypes.shape({
    paymentId: PropTypes.number,
    contractId: PropTypes.number,
    paymentStatus: PropTypes.string,
    paymentTransactionUid: PropTypes.string,
    paymentTransactionRequestUid: PropTypes.string,
    paymentAmount: PropTypes.number,
    paymentTax: PropTypes.number,
    failedCount: PropTypes.number,
    expectedPaymentDate: PropTypes.number,
    expectedPaymentMonth: PropTypes.number,
    paymentTime: PropTypes.number,
    createdTime: PropTypes.number,
    updatedTime: PropTypes.number,
  })).isRequired,
  currency: PropTypes.string.isRequired,
  currencyType: PropTypes.instanceOf(CurrencyType).isRequired,
};

export default PaymentHistory;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentHistory/PaymentHistory.js